<template>
    <form @submit="submit_form" class="js-validate">

        <div class="js-form-message form-group mb-3">
            <textarea v-model="message" class="form-control" rows="7" id="descriptionTextarea"
                      placeholder="Commentaire" required
                      data-msg="Veuillez entrer votre commentaire."
                      data-error-class="u-has-error"
                      data-success-class="u-has-success"></textarea>
        </div>
        <!-- Submit Errors -->
        <div class="mb-7">
            <p v-if="error" class="text-danger">{{ error }}</p>
        </div>
        <!-- End Submit Errors -->

        <div class="d-flex justify-content-center">
            <LoadingButton v-if="requestIsLoading"/>
            <button v-else type="submit" class="btn btn-primary btn-wide transition-3d-hover">Envoyer</button>
        </div>
    </form>
</template>

<script>
    import {GET_POST, MAKE_COMMENT} from "../settings/graphql";
    import LoadingButton from "./LoadingButton";
    import {errorMessageDisplay} from "../xlib/graphql";

    export default {
        name: "PostCommentForm",
        components: {LoadingButton},
        props: ["postId"],
        data() {
            return {
                message: "",
                author: this.$store.state.user.info,
                error: null,
                requestIsLoading: false,
            };
        },
        methods: {
            submit_form: function (event) {
                event.preventDefault();

                this.$data.requestIsLoading = true;
                let {message, author} = this.$data;
                const {postId} = this.$props;

                const self = this;
                this.$apollo.mutate({
                    mutation: MAKE_COMMENT,
                    variables: {postId, message},
                    update: (cache) => {
                        // console.log(`Updating post ${result} ... `);
                        // console.log(`Comment author: ${author}`);

                        let getPostData = cache.readQuery({
                            query: GET_POST,
                            variables: {id: postId}
                        });

                        // console.log(`Get post previous data: ${JSON.stringify(getPostData)}`);

                        getPostData.post.commentSet.edges.unshift({
                            node: {
                                message: message,
                                author: author,
                                __typename: "CommentNode"
                            },
                            __typename: "CommentNodeEdge"
                        });

                        cache.writeQuery({
                            query: GET_POST,
                            data: getPostData
                        });
                    }
                }).then(() => {
                    // console.log(`Comment successfully posted ${result}`);
                    self.$data.message = "";
                    self.$data.requestIsLoading = false;
                }).catch((error) => {
                    // console.error(`Error ${JSON.stringify(error)} on comment posting`);
                    this.$data.error = errorMessageDisplay(error);
                });
            }
        }
    }
</script>

<style scoped>

</style>